import * as React from 'react';

import PaylabLogo from 'assets/images/PaylabLogo.png';

export type LogoProps = React.ImgHTMLAttributes<HTMLImageElement>;

const Logo: React.FC<LogoProps> = ({ className, alt = 'PayLab.tech', ...rest }) => {
  return (
    <img
      src={PaylabLogo}
      alt={alt}
      className={className}
      {...rest}
    />
  );
};

export default React.memo(Logo);
